import React, { useEffect, useState } from "react";
import { hasRdProfileImage } from "./registrationMatchedRd";

const RegistrationRdAvatar = ({
  className = "rd-avatar",
  profileImage,
  initials,
  avatarStyle,
  alt = "",
}) => {
  const [imageError, setImageError] = useState(false);
  const hasImage = hasRdProfileImage(profileImage);
  const showImage = hasImage && !imageError;

  useEffect(() => {
    setImageError(false);
  }, [profileImage]);

  return (
    <div
      className={className}
      style={showImage ? undefined : { background: avatarStyle }}
    >
      {showImage ? (
        <img
          src={profileImage}
          alt={alt}
          onError={() => setImageError(true)}
          onLoad={(event) => {
            if (event.currentTarget.naturalWidth === 0) {
              setImageError(true);
            }
          }}
        />
      ) : (
        initials
      )}
    </div>
  );
};

export default RegistrationRdAvatar;
